import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AlloxApiService } from './allox-api.service';
import { TesterDeviceSearchParam, TesterDevice } from '../models';

@Injectable({ providedIn: 'root' })
export class TesterDeviceService {

  private path = '/tester_devices';

  constructor(private http: AlloxApiService) { }

  public search(param: TesterDeviceSearchParam) {
    return this.http.get<[]>(this.path + param.toURLQuery()).pipe(
      map(objs => objs.map(obj => new TesterDevice(obj)))
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new TesterDevice(obj))
    );
  }

  public post(item: TesterDevice) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: TesterDevice) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: TesterDevice[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
